<template>
    <v-row class="ma-0 pa-0" justify="space-around">
        <!-- <v-col class="ma-0 pa-0" cols="auto">
            <span class="chart_title">{{ statistic_title_name == null ? statistic_name : statistic_title_name }}</span>
        </v-col> -->
        <v-col cols="12" :style="{height: chart_height + 'px'}">
            <v-chart
                class="chart_style"
                :option="graph_options"
                autoresize
                :ref="chart_ref"
                :id="chart_id"
            ></v-chart>
        </v-col>
    </v-row>
</template>

<script>

import VChart, { THEME_KEY } from 'vue-echarts';
import { use } from 'echarts/core';
import { CanvasRenderer } from 'echarts/renderers'; 'echarts/charts';
import {
    TitleComponent,
    TooltipComponent,
    LegendComponent,
} from 'echarts/components';

use([
    CanvasRenderer,
    TitleComponent,
    TooltipComponent,
    LegendComponent,
]);

export default {
    name: 'PredictionBarChartOverview',
    props: [
        'statistic_title_name',
        'value',
        'chart_ref',
        'chart_id',
        'link'
    ],
    provide: {
        [THEME_KEY]: 'light',
    },
    components: {
        VChart
    },
    data: () => ({
        chart_height: screen.height * 0.2,
        data: [],
    }),
    watch: {
        // value: function(){
        //     if(this.value != null){
        //         this.data = this.value;
        //         let series_over = {}
        //         if(this.data.length > 0){
        //             let total_opts = (this.data[0].length - 1);
        //             let num_opts = total_opts / 2;
        //             for(let i = 0; i < total_opts; i ++ ){
        //                 if(i < num_opts){
        //                     series_over[i] = {'targetAxisIndex': 0};
        //                 }
        //                 else{
        //                     series_over[i] = {'targetAxisIndex': 1};
        //                 }
        //             }
        //             this.options['series'] = series_over;
        //         }
        //     }
        // }
    },
    mounted(){
        // if(this.value != null){
        //     this.data = this.value;
        //     let series_over = {}
        //     if(this.data.length > 0){
        //         let total_opts = (this.data[0].length - 1);
        //         let num_opts = total_opts / 2;
        //         for(let i = 0; i < total_opts; i ++ ){
        //             if(i < num_opts){
        //                 series_over[i] = {'targetAxisIndex': 0};
        //             }
        //             else{
        //                 series_over[i] = {'targetAxisIndex': 1};
        //             }
        //         }
        //         this.options['series'] = series_over;
        //     }
        // }
    },
    methods: {
        open_further_details: function(){
            if(this.link){
                this.$router.replace(this.link);
            }
        }
    },
    computed: {
        graph_options: function() {

            // let dataset = JSON.parse(JSON.stringify(this.value));
            // // let dataset = this.value

            // let data_category = ['metrics']
            let data_series = []
            // // let data = []
            let dataSource = this.value;
            data_series = [...dataSource[0]]
            data_series.shift();

            // const colors = ['#FF0000', '#0000FF'];  // red, blue for first and second bars

            // const series = [];
            // const metrics = ['Spend', 'Volume', 'ROAS'];
            // const segments = ['Base', 'Low Risk'];  // from your columns 1 and 2

            // metrics.forEach((metric, metricIndex) => {
            //     segments.forEach((segment, segmentIndex) => {
            //         series.push({
            //         name: segment,
            //         type: 'bar',
            //         xAxisIndex: metricIndex,
            //         yAxisIndex: metricIndex,
            //         seriesLayoutBy: 'row', // because dataset rows are metric-based
            //         encode: { x: 'metrics', y: metricIndex + 1, itemName: 'metrics' },
            //         // +1 because column 0 is "metrics" (Spend, Volume, ROAS)
            //         itemStyle: { color: colors[segmentIndex % colors.length] },
            //         barWidth: '60%',
            //         });
            //     });
            // });
            
            // const graph_option = {
            //     color: [ '#F4B400', '#00C49F', '#FFBB28', '#FF6666', '#4C9BFF', '#4CD7D0'], // Extend if more bars
            //     tooltip: {
            //         trigger: 'axis',
            //         axisPointer: { type: 'shadow' },
            //         backgroundColor: '#fff',
            //         borderColor: '#ccc',
            //         borderWidth: 1,
            //         textStyle: {
            //             color: '#333',
            //             fontFamily: 'Poppins'
            //         },
            //         formatter: function (params) {

            //             const body = params.map(item => {
            //                 return `${item.name || ''}: $${Intl.NumberFormat('en', { notation: 'compact', maximumFractionDigits: 2, minimumFractionDigits: 1 }).format(item.value[item.seriesIndex+1]) || ''}`;
            //             }).join('<br/>');

            //             return `${body}`;
            //         }
            //     },
            //     dataset: { source: dataSource },
            //     legend: {
            //         // show: false,
            //         data: data_series,
            //         top: 10,
            //         textStyle: { fontFamily: 'Poppins' }
            //     },
            //     xAxis: [
            //         {
            //             type: 'category',
            //             gridIndex: 0,
            //             name: 'Spend',
            //             nameLocation: 'center',
            //             nameGap: 25,
            //             nameTextStyle: { fontSize: 16, fontFamily: 'Poppins' },
            //             axisLabel: {
            //                 interval: 0,
            //                 fontSize: 0,
            //                 fontFamily: 'Poppins',
            //                 margin: 10
            //             }
            //         },
            //         {
            //             type: 'category',
            //             gridIndex: 1,
            //             name: 'Volume',
            //             nameLocation: 'center',
            //             nameGap: 25,
            //             nameTextStyle: { fontSize: 16, fontFamily: 'Poppins' },
            //             axisLabel: {
            //                 interval: 0,
            //                 fontSize: 0,
            //                 fontFamily: 'Poppins',
            //                 margin: 10
            //             }
            //         },
            //         {
            //             type: 'category',
            //             gridIndex: 2,
            //             name: 'ROAS',
            //             nameLocation: 'center',
            //             nameGap: 25,
            //             nameTextStyle: { fontSize: 16, fontFamily: 'Poppins' },
            //             axisLabel: {
            //                 interval: 0,
            //                 fontSize: 0,
            //                 fontFamily: 'Poppins',
            //                 margin: 10
            //             }
            //         }
            //     ],
            //     yAxis: [
            //         {
            //             gridIndex: 0,
            //             axisLabel: {
            //                 formatter: function (value) {
            //                     if (value >= 1e9) return '$' + (value / 1e9).toFixed(1).replace(/\.0$/, '') + 'B';
            //                     if (value >= 1e6) return '$' + (value / 1e6).toFixed(1).replace(/\.0$/, '') + 'M';
            //                     if (value >= 1e3) return '$' + (value / 1e3).toFixed(1).replace(/\.0$/, '') + 'K';
            //                     return '$' + value.toFixed(1);
            //                 },
            //                 fontSize: 11,
            //                 fontFamily: 'Poppins',
            //                 margin: 12
            //             }
            //         },
            //         {
            //             gridIndex: 1,
            //             axisLabel: {
            //                 formatter: function (value) {
            //                     if (value >= 1e9) return '$' + (value / 1e9).toFixed(1).replace(/\.0$/, '') + 'B';
            //                     if (value >= 1e6) return '$' + (value / 1e6).toFixed(1).replace(/\.0$/, '') + 'M';
            //                     if (value >= 1e3) return '$' + (value / 1e3).toFixed(1).replace(/\.0$/, '') + 'K';
            //                     return '$' + value.toFixed(1);
            //                 },
            //                 fontSize: 11,
            //                 fontFamily: 'Poppins',
            //                 margin: 12
            //             }
            //         },
            //         {
            //             gridIndex: 2,
            //             axisLabel: {
            //                 formatter: function (value) {
            //                     if (value >= 1e9) return '$' + (value / 1e9).toFixed(1).replace(/\.0$/, '') + 'B';
            //                     if (value >= 1e6) return '$' + (value / 1e6).toFixed(1).replace(/\.0$/, '') + 'M';
            //                     if (value >= 1e3) return '$' + (value / 1e3).toFixed(1).replace(/\.0$/, '') + 'K';
            //                     return '$' + value.toFixed(1);
            //                 },
            //                 fontSize: 11,
            //                 fontFamily: 'Poppins',
            //                 margin: 12
            //             }
            //         }
            //     ],
            //     grid: [
            //         { left: '5%', width: '23%', bottom: 40, top:5 },
            //         { left: '38.5%', width: '23%', bottom: 40, top:5 },
            //         { left: '72%', width: '23%', bottom: 40, top:5 }
            //     ],
            //     series: series
            // };



            function flipDataset(data) {
                const headers = data[0].slice(1);   // ['Base', 'Low Risk']
                const metrics = data.slice(1).map(row => row[0]); // ['Spend', 'Volume', 'ROAS']

                // Initialize flipped data with header row
                const flipped = [];
                flipped.push(['Segment', ...metrics]);

                // For each segment, build a row of [segmentName, val1, val2, val3]
                headers.forEach((segment, colIdx) => {
                    const row = [segment];
                    for(let rowIdx = 1; rowIdx < data.length; rowIdx++) {
                    row.push(data[rowIdx][colIdx + 1]);
                    }
                    flipped.push(row);
                });
                return flipped;
            }
            const flippedData = flipDataset(dataSource);
            const metrics = ['Spend', 'Volume', 'ROAS'];
            const colors = [
                '#FF4C4C', // Red
                '#4C9BFF', // Blue
                '#4CD7D0', // Teal
                '#F4B400', // Yellow
                '#A07BFF', // Purple
                '#00C49F', // Green
                '#FFBB28'  // Orange
            ];

            const series = metrics.map((metric, idx) => ({
            name: metric,
            type: 'bar',
            xAxisIndex: idx,
            yAxisIndex: idx,
            encode: { x: 'Segment', y: metric },
            barWidth: '60%',
            itemStyle: {
                color: function(params) {
                // params.dataIndex = 0 for 'Base', 1 for 'Low Risk'
                return colors[params.dataIndex] || '#000'; // fallback black if needed
                }
            }
            }));
            const graph_option = {
                dataset: {
                    source: flippedData
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: { type: 'shadow' },
                    backgroundColor: '#fff',
                    borderColor: '#ccc',
                    borderWidth: 1,
                    textStyle: {
                    color: '#333',
                    fontFamily: 'Poppins'
                    },
                    formatter: function(params) {
                    return params.map(item => {
                        const metricIndex = flippedData[0].indexOf(item.seriesName);
                        const val = item.value[metricIndex];
                        const formattedVal = Intl.NumberFormat('en', { notation: 'compact', maximumFractionDigits: 2 }).format(val);
                        return `${item.name}: $${formattedVal}`;
                    }).join('<br/>');
                    }
                },
                legend: {
                    show: false
                },
                grid: [
                    { left: '5%', width: '23%', bottom: 40, top:5 },
                    { left: '38.5%', width: '23%', bottom: 40, top:5 },
                    { left: '72%', width: '23%', bottom: 40, top:5 }
                ],
                xAxis: [
                    {
                        type: 'category',
                        gridIndex: 0,
                        name: 'Spend',
                        nameLocation: 'center',
                        nameGap: 25,
                        nameTextStyle: { fontSize: 16, fontFamily: 'Poppins' },
                        axisLabel: { show: false }  // hide labels
                    },
                    {
                        type: 'category',
                        gridIndex: 1,
                        name: 'Volume',
                        nameLocation: 'center',
                        nameGap: 25,
                        nameTextStyle: { fontSize: 16, fontFamily: 'Poppins' },
                        axisLabel: { show: false }  // hide labels
                    },
                    {
                        type: 'category',
                        gridIndex: 2,
                        name: 'ROAS',
                        nameLocation: 'center',
                        nameGap: 25,
                        nameTextStyle: { fontSize: 16, fontFamily: 'Poppins' },
                        axisLabel: { show: false }  // hide labels
                    }
                ],
                yAxis: [
                    {
                        gridIndex: 0,
                        type: 'value',
                        axisLabel: {
                            formatter: function(value) {
                                if (value >= 1e9) return '$' + (value / 1e9).toFixed(1).replace(/\.0$/, '') + 'B';
                                if (value >= 1e6) return '$' + (value / 1e6).toFixed(1).replace(/\.0$/, '') + 'M';
                                if (value >= 1e3) return '$' + (value / 1e3).toFixed(1).replace(/\.0$/, '') + 'K';
                                return '$' + value.toFixed(1);
                            },
                            fontSize: 11,
                            fontFamily: 'Poppins'
                        }
                    },
                    {
                        gridIndex: 1,
                        type: 'value',
                        axisLabel: {
                            formatter: function(value) {
                                if (value >= 1e9) return '$' + (value / 1e9).toFixed(1).replace(/\.0$/, '') + 'B';
                                if (value >= 1e6) return '$' + (value / 1e6).toFixed(1).replace(/\.0$/, '') + 'M';
                                if (value >= 1e3) return '$' + (value / 1e3).toFixed(1).replace(/\.0$/, '') + 'K';
                                return '$' + value.toFixed(1);
                            },
                            fontSize: 11,
                            fontFamily: 'Poppins'
                        }
                    },
                    {
                        gridIndex: 2,
                        type: 'value',
                        axisLabel: {
                            formatter: function(value) {
                                if (value >= 1e9) return '$' + (value / 1e9).toFixed(1).replace(/\.0$/, '') + 'B';
                                if (value >= 1e6) return '$' + (value / 1e6).toFixed(1).replace(/\.0$/, '') + 'M';
                                if (value >= 1e3) return '$' + (value / 1e3).toFixed(1).replace(/\.0$/, '') + 'K';
                                return '$' + value.toFixed(1);
                            },
                            fontSize: 11,
                            fontFamily: 'Poppins'
                        }
                    }
                ],
                series: series
            };



            return graph_option
        },
    }
}
</script>

<style scoped>
    .chart_title{
        font-family: "Poppins" !important;
        font-weight: 600;
        font-size: 12pt !important;
        line-height: 40px;

        display: block;
        max-width: 200px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
</style>